<template lang="pug">
.container.properties
  auto-edit-table(:defines='$defines.property', unstackable, :data='filtered', title='库存信息', :pagesize='30')
    filters-group(:data='properties', :result.sync='filtered', slot='afterTitle')
      .ui.two.columns.stackable.form.grid.filters
        .column
          h4 筛选
          filter-select(:filter='$defines.property.filters.select')
        .column
          h4 搜索
          filter-search(:filter='$defines.property.filters.search', placeholder='搜索...')
</template>

<script>
import { AutoEditTable } from '../components/auto'
import { FiltersGroup, FilterSearch, FilterSelect } from '../components/filters'

export default {
  name: 'properties',
  components: {
    AutoEditTable,
    FilterSearch,
    FilterSelect,
    FiltersGroup,
  },
  computed: {
    properties() {
      return this.$store.getters.properties
    },
  },
  data() {
    return {
      filtered: [],
    }
  },
}
</script>



// WEBPACK FOOTER //
// Properties.vue?91a7bc08